/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_DedupInputs */

const en_svchip_dedup = /** @type {(inputs: Svchip_DedupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dedup`)
};

const ar_svchip_dedup = /** @type {(inputs: Svchip_DedupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إزالة التكرار`)
};

const bn_svchip_dedup = /** @type {(inputs: Svchip_DedupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডিডুপ`)
};

const de_svchip_dedup = /** @type {(inputs: Svchip_DedupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dedup`)
};

const es_svchip_dedup = /** @type {(inputs: Svchip_DedupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desduplicación`)
};

const fr_svchip_dedup = /** @type {(inputs: Svchip_DedupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déduplication`)
};

const pt_svchip_dedup = /** @type {(inputs: Svchip_DedupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desduplicação`)
};

const zh_svchip_dedup = /** @type {(inputs: Svchip_DedupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重复数据删除`)
};

const tr_svchip_dedup = /** @type {(inputs: Svchip_DedupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dedup`)
};

const ru_svchip_dedup = /** @type {(inputs: Svchip_DedupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дедупляция`)
};

const pl_svchip_dedup = /** @type {(inputs: Svchip_DedupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deduplikacja`)
};

/**
* | output |
* | --- |
* | "Dedup" |
*
* @param {Svchip_DedupInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_dedup = /** @type {((inputs?: Svchip_DedupInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_DedupInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_dedup(inputs)
	if (locale === "bn") return bn_svchip_dedup(inputs)
	if (locale === "de") return de_svchip_dedup(inputs)
	if (locale === "es") return es_svchip_dedup(inputs)
	if (locale === "fr") return fr_svchip_dedup(inputs)
	if (locale === "pt") return pt_svchip_dedup(inputs)
	if (locale === "zh") return zh_svchip_dedup(inputs)
	if (locale === "tr") return tr_svchip_dedup(inputs)
	if (locale === "ru") return ru_svchip_dedup(inputs)
	if (locale === "pl") return pl_svchip_dedup(inputs)
	return en_svchip_dedup(inputs)
});